import React, {useCallback, useEffect, useState} from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { baseUrl } from "../../../../constants/Constant";
import makeAnimated from "react-select/animated";
import FlagIconFactory from "react-flag-icon-css";
const FlagIcon = FlagIconFactory(React, { useCssModules: false })

const animatedComponents = makeAnimated();

const ItemSelected = ({
	                      fieldType,
	                      selecte,
	                      onchange,
	                      item,
	                      placeholder,
	                      blockType = "conditions",
	                      value,
	                      singleSelect = false,
	                      menuPortalTarget = undefined,
	                      menuPosition = undefined,
                      }) => {
	let [selectItems, SetSelectItems] = useState(singleSelect ? null : []);
	useEffect(() => {
		const fetchData = async () => {
			try {
				const items = await Promise.resolve(selecte);
				if (singleSelect) {
					SetSelectItems(items || null);
				} else {
					SetSelectItems(Array.isArray(items) ? items : []);
				}
			} catch (error) {
				console.error("Error resolving selecte prop", error);
				SetSelectItems(singleSelect ? null : []);
			}
		};

		if (selecte !== undefined && selecte !== null) {
			fetchData();
		}
	}, [selecte, singleSelect]);

	useEffect(() => {
		if (value !== undefined && value !== null) {
			if (singleSelect) {
				SetSelectItems(value);
			} else {
				SetSelectItems(Array.isArray(value) ? value : []);
			}
		} else {
			SetSelectItems(singleSelect ? null : []);
		}
	}, [value, singleSelect]);

	const [isLoading, setIsLoading] = useState(false);
  // Fetch options asynchronously based on search input
  const fetchOptions = async (inputValue) => {
	  // If no input, use empty string to get initial results
	  const searchQuery = inputValue || '';
    setIsLoading(true);
    try {
      let response;
      let fetchedOptions = [];

      // API call based on field type
      switch (fieldType) {
        case "Product SKU":
          response = await axios.get(
	          `${baseUrl}api/v1/product/sku/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.product_code,
            imageUrl: option.default_image_url,
          }));
          break;
        case "Product":
          response = await axios.get(
	          `${baseUrl}api/v1/product/sku/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.item_id,
            imageUrl: option.resized_image_url || option.default_image_url,
          }));
          break;
        case "Product ID":
          response = await axios.get(
	          `${baseUrl}api/v1/product/id/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.item_id,
            imageUrl: option.default_image_url,
          }));
          break;
	      case "Category":
	      case "CATEGORY":
          response = await axios.get(
	          `${baseUrl}api/v1/categories/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.cat_id,
            imageUrl: option.image,
          }));
          break;
	      case "Subcategory":
	      case "SUBCATEGORY":
          response = await axios.get(
	          `${baseUrl}api/v1/subcategories/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.sub_cat_id,
            imageUrl: option.image,
          }));
          break;
        case "Supplier":
          response = await axios.get(
	          `${baseUrl}api/v1/suppliers/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.first_name,
            value: option.first_name,
            id: option.id,
            imageUrl: option.supplier_logo,
          }));
          break;
        case "Brand":
          response = await axios.get(
	          `${baseUrl}api/v1/brand/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.brand_id,
            imageUrl: option.image,
          }));
          break;
        case "Country":
          response = await axios.get(
	          `${baseUrl}api/v1/countries/${searchQuery}`
          );
          fetchedOptions = response.data.data.data.data.map((option) => ({
            label: option.name,
            value: option.name,
            id: option.id,
            imageUrl: option.code,
          }));
          break;
	      case "Dietary":
		      response = await axios.get(
			      `${baseUrl}api/v1/dietary/${searchQuery}`
		      );
		      const dietaryData = response.data.data.data.data;
		      if (!dietaryData || !Array.isArray(dietaryData)) {
			      fetchedOptions = [];
			      break;
		      }
		      fetchedOptions = dietaryData.map((option) => ({
			      label: option.name,
			      value: option.name,
			      id: option.diet_id,
			      imageUrl: option.image_url,
		      }));
		      console.log('Dietary Fetched Options:', fetchedOptions);
		      break;

        case "DelipointTier":
          response = await axios.get(
            `${baseUrl}api/v1/delipoints/tiers/list?search=${searchQuery}`,
            { headers: { Authorization: localStorage.getItem("token") } }
          );
          const tierData = response.data.data?.list || response.data.data || [];
          fetchedOptions = (Array.isArray(tierData) ? tierData : []).map((option) => ({
            label: option.name,
            value: option.name,
            id: option.dp_tier_id ?? option._id ?? option.id,
            imageUrl: option.image,
          }));
          break;

        default:
          fetchedOptions = [];
          break;
      }

      return fetchedOptions;
    } catch (error) {
      console.error("Error fetching options", error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  // Custom option label with image and text
  const formatOptionLabel = ({ label, imageUrl }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      {imageUrl && fieldType !== "Country" ? (
        <img
          src={imageUrl}
          alt={label}
          style={{ width: "30px", height: "30px", marginRight: "10px" }}
        />
      ):
         ( <span style={{ height: 'fit-content' }}>
             <FlagIcon code={imageUrl?.toLowerCase()} />
          </span>)
      }
      <span>{label}</span>
    </div>
  );

	const handleChange = useCallback(
		(selectedOptions) => {
			if (blockType === "conditions") {
				onchange(item.block, item.conditionIndex, fieldType, {
					selectedList: selectedOptions,
				});
			} else {
				onchange(selectedOptions);
			}
		},
		[blockType, item, fieldType, onchange]
	);
	return (
		// In your ItemSelected component file, update the styles object in AsyncSelect:

		<AsyncSelect
			style={{height: "100%"}}
			isMulti={!singleSelect}
			className="basic-multi-select"
			classNamePrefix="select"
			// cacheOptions
			defaultOptions
			components={animatedComponents}
			loadOptions={fetchOptions}
			placeholder={isLoading ? "Loading options..." : placeholder}
			formatOptionLabel={formatOptionLabel}
			onChange={handleChange}
			value={selectItems}
			menuPlacement="auto"
			menuPortalTarget={menuPortalTarget}
			menuPosition={menuPosition}
			styles={{
				control: (provided, state) => ({
					...provided,
					minHeight: "55px",
					borderColor: state.isFocused ? "#9cc54b" : "#e2e8f0",
					borderWidth: "2px",
					borderRadius: "12px",
					boxShadow: state.isFocused ? "0 0 0 3px rgba(156, 197, 75, 0.1)" : "none",
					transition: "all 0.3s ease",
					"&:hover": {
						borderColor: "#9cc54b",
					},
				}),
				menuPortal: (provided) => ({
					...provided,
					zIndex: 999999,
				}),
				menu: (provided) => ({
					...provided,
					zIndex: 99999,
					borderRadius: "12px",
					overflow: "hidden",
					boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
					border: "1px solid #e2e8f0",
				}),
				menuList: (provided) => ({
					...provided,
					padding: "8px",
					maxHeight: "300px",
				}),
				option: (provided, state) => ({
					...provided,
					backgroundColor: state.isSelected
						? "#9cc54b"
						: state.isFocused
							? "rgba(156, 197, 75, 0.1)"
							: "transparent",
					color: state.isSelected ? "#fff" : "#2d3748",
					borderRadius: "8px",
					margin: "2px 0",
					padding: "10px 12px",
					cursor: "pointer",
					transition: "all 0.2s ease",
					"&:active": {
						backgroundColor: "#8ab43d",
					},
				}),
				multiValue: (provided, {data}) => ({
					...provided,
					backgroundColor: !data?.is_available
						? "#2d3748"
						: data?.oos
							? "#718096"
							: "#9cc54b",
					borderRadius: "8px",
					padding: "2px 4px",
					transition: "all 0.2s ease",
				}),
				multiValueLabel: (provided) => ({
					...provided,
					color: "#fff",
					fontWeight: "500",
					padding: "4px 8px",
					fontSize: "0.875rem",
				}),
				multiValueRemove: (provided) => ({
					...provided,
					color: "#fff",
					borderRadius: "0 6px 6px 0",
					padding: "0 6px",
					cursor: "pointer",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#e53e3e",
						color: "#fff",
					},
				}),
				placeholder: (provided) => ({
					...provided,
					color: "#a0aec0",
					fontSize: "0.95rem",
				}),
				input: (provided) => ({
					...provided,
					color: "#2d3748",
				}),
				indicatorSeparator: (provided) => ({
					...provided,
					backgroundColor: "#e2e8f0",
				}),
				dropdownIndicator: (provided, state) => ({
					...provided,
					color: state.isFocused ? "#9cc54b" : "#a0aec0",
					transition: "all 0.2s ease",
					"&:hover": {
						color: "#9cc54b",
					},
				}),
				clearIndicator: (provided) => ({
					...provided,
					color: "#a0aec0",
					transition: "all 0.2s ease",
					"&:hover": {
						color: "#e53e3e",
					},
				}),
			}}
		/>
  );
};

export default ItemSelected;
